{
  "code": "EX-00",
  "@GENERAL": "General translations",
  "AFFINITY": "Afinidad",
  "CAMPAIGNS": "Parrillas Promocionales",
  "COLLABORATOR_ALT": "Colaborador",
  "CONTACT": "Contacto",
  "DYNAMIC_FORMS": "Mis Formularios",
  "DYNAMIC_FORMS_LOADED": "Formularios sincronizados: {{value}}",
  "DYNAMIC_FORMS_SEARCH": "Buscar formularios",
  "DYNAMIC_FORMS_SELECTED": "Encuesta #{{value}}",
  "FILTER_INFO": "Para el filtro <span class=\"font-italic font-bold text-primary\">{{parameterType}}:</span> <span class\"font-italic\">{{parameterValue}}</span>",
  "GENERAL": "General",
  "LINE": "Línea",
  "NO_FILTER": "",
  "OTHER": "Otros",
  "PRODUCT": "Producto",
  "RETURN": "Regresar",
  "SAVE": "Guardar",
  "SEGMENT": "Segmento",
  "SEGMENTS": "Segmentos",
  "SUPERVISOR": "Supervisor",
  "TODOS": "Todos",
  "VALUE_OF_VALUE": "{{label1}} de {{label2}}",

  "ACTIONS": {
    "UPDATE": "Actualizar"
  }
}
